<template>
  <!--<div>-->
  <div class="mobileBox">
    <!--banner+导航-->
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/applyBanner_m.png"/>


      <top-nav></top-nav>


    </div>

    <div class="aboutContent">

      <div class="about01" id="m1">
        <div class="imgBox"><img src="../../../assets/icon/aboutImg1.png"/></div>
        <div class="textBox animated" :class="mm1 ? 'fadeInRight' : 'hideBox'">
          <div class="titleText">OUR COMPANY</div>
          <div class="contentText">
            <p>To satisfy the increasing payment demands of enterprises and businesses engaged in the cross- border trading, SuperiorPay developes the "global payment solution" with "cross-border payment, mobile payment, O2O payment, multi-channel auditing, big-data-based risk control, and online marketing" as the business cores.</p>
            <p>It solves the problems of Internet transaction, such as"low payment conversion, unsystematic service fee, and high trading risks”, greatly promotes the efficiency of payment processing and boosts the improvement of the online trading industry.</p>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>

      <div class="about02" id="m2">
        <div class="imgBox"><img src="../../../assets/icon/aboutImg2.png"/></div>
        <div class="textBox animated" :class="mm2 ? 'fadeInLeft' : 'hideBox'">
          <div class="titleText">OUR PAYMENT PRODUCT</div>
          <div class="contentText">
            <p>SuperiorPay has covered the most mainstream mobile payment methods including Alipay and WeChat Pay. It is equipped with automatic service fee calculation and one-stop financial data management and supports multi-channel account checking, easy backstage operation and strong statistical functions. We are able to create group accounts for businesses, which can keep you abreast of the business status of your branches.</p>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>

      <div class="about01 about03" id="m3">
        <div class="imgBox"><img src="../../../assets/icon/aboutImg3.png"/></div>
        <div class="textBox animated" :class="mm3 ? 'fadeInRight' : 'hideBox'">
          <div class="titleText">SECURITY</div>
          <div class="contentText">
            <p>In terms of security, our company is authorised with the Australian financial license, with the funds managed by Australian bank. The company is in official cooperation with WeChat and Alipay and employs AML（Anti Money Laundering）and AF (Anti-Fraud) regulations for risk control. Our infrastructure is with bank-grade security. Data transmission and storage adopts encryption algorithm, which allows the funds credited into the account safely and in time.</p>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>


    </div>

    <!--底部-->
    <div class="footer_m ">
      <div class="footer_mText">
        Supay Technology Pty Ltd. Authorized Representative Number 001283947
        <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
      </div>
    </div>

  </div>
  <!--</div>-->
</template>

<script>
  import topNav from './nav_m'
  let timer = null; //定义初始值
  export default {
    name: "about_m",
    components:{topNav},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        mm1:false,
        mm2:false,
        mm3:false,
        mm4:false,
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;
      this.mm1 = true;
      this.mm2 = true;
      this.mm3 = true;
      // this.mm2 = true;
      // this.mm3 = true;
      // window.addEventListener('scroll', this.handleScroll);
    },
    methods:{


      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        var offsetTop1 = document.querySelector('#m1').offsetTop;
        // var offsetTop2 = document.querySelector('#m2').offsetTop;
        var offsetTop3 = document.querySelector('#m3').offsetTop;




        if (scrollTop > offsetTop1-600) {
          this.mm2 = true
        }
        if (offsetTop3-scrollTop > 500) {
          this.mm3 = true
        }
      },


      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>
  .mobileBox{width: 100%;height: auto;overflow: hidden;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}

  .aboutContent{width: 100%;height: auto;margin-top: -3px;}

  /*版块1*/
  .about01{width: 100%;height: auto;margin-top: -3px;position: relative;}
  .about01 .imgBox{width: 85%;height: auto;float: left;position: absolute;}
  .about01 .imgBox>img{width: 100%;height: auto;}
  .about01 .textBox{width: 60%;min-width: 14rem; min-height: 25rem;overflow-y: auto;float: right;margin-right: 15px;background-color: #fff;margin-top: 3.125rem; padding: 20px;right: 0;box-shadow: 0 0 30px 0px rgba(0,0,0,0.2);position: relative;z-index: 99;}
  .about01 .textBox .titleText{font-size: 1rem;font-family: OpenSans600;color: #4a4a4a;width: 100%;line-height: 2.5rem;text-align: left;}
  .about01 .textBox .contentText{width:100%;height: calc(100% - 10rem);font-family: Montserrat300;font-size: 0.75rem;color: #4a4a4a;line-height: 1.2rem;text-align: left;}
  .about01 .textBox .contentText>p{margin: 10px 0;}

  /*版块2*/
  .about02{width: 100%;height: auto;margin-top: -50px;position: relative;}
  .about02 .imgBox{width: 85%;height: auto;float: right;position: absolute;right: 0;}
  .about02 .imgBox>img{width: 100%;height: auto;}
  .about02 .textBox{width: 60%;min-width: 14rem;min-height: 25rem;overflow-y: auto; float: left;margin-left: 15px;background-color: #fff;margin-top: 11.25rem; padding: 20px;right: 0;box-shadow: 0 0 30px 0px rgba(0,0,0,0.2);position: relative;z-index: 99;}
  .about02 .textBox .titleText{font-size: 1rem;font-family: OpenSans600;color: #4a4a4a;width: 100%;line-height: 2.5rem;text-align: left;}
  .about02 .textBox .contentText{width:100%;height: calc(100% - 10rem);font-family: Montserrat300;font-size: 0.75rem;color: #4a4a4a;line-height: 1.2rem;text-align: left;}
  .about02 .textBox .contentText>p{margin: 10px 0;}


  /*板块3*/
  .about03{margin-top: -50px;margin-bottom: 100px;}
  .about03 .textBox{margin-top: 12.5rem;}

  .hideBox{display: none;}


  @media screen and (min-width: 760px) {
    .about01 .textBox{width: 50%;margin-top: 17.125rem;}
    .about02{margin-top: -65px;}
    .about02 .textBox{width: 50%;}
    .about01 .imgBox{width: 75%;}
    .about02 .imgBox{width: 75%;}
  }
  @media screen and (min-width: 950px) {
    .about01 .imgBox{width: 65%;}
    .about02 .imgBox{width: 65%;}
    .about01 .textBox{width: 45%;margin-top: 25.125rem;}
    .about02 .textBox{width: 45%;margin-top: 22.25rem;}
    .about02{margin-top: -50px;}

  }




</style>
